module.exports = __webpack_public_path__ + "static/media/GnomeInset.de3365ee.svg";